import { IntegrationService, ApiSuccess, IntegrationUser } from '../../types';
import { apiSlice } from '../api.services';

interface IntegrationUsersResponseData {
  users: IntegrationUser[];
}

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIntegrationUsers: builder.query<IntegrationUsersResponseData, { service: IntegrationService }>({
      query: ({ service }) => `/integrations/${service.toLowerCase()}/users`,
      transformResponse: (response: ApiSuccess<IntegrationUsersResponseData>) => response.data,
    }),
  }),
});

export const { useGetIntegrationUsersQuery } = enhancedApiSlice;
